import { axiosInstance } from "../client";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { Role } from "@rumble-it/common-lib/types/models/Role.interface";
import { Permission } from "@rumble-it/common-lib/types/models/Permission.interface";
import { RoleFormValues } from "../../../pages/admin/roles/RoleCreate";

export const fetchRoles = async (): Promise<Role[]> =>
  axiosInstance.get(`/admin/users/roles`).then((response) => response.data);

export const fetchRoleById = async (id: string): Promise<Role> =>
  axiosInstance
    .get(`/admin/users/roles/${id}`)
    .then((response) => response.data);

export const createRole = async (data: RoleFormValues): Promise<null> =>
  axiosInstance
    .post(`/admin/users/roles`, data)
    .then((response) => response.data);

export const updateRoleById = async (
  id: string,
  data: RoleFormValues,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/users/roles/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteRoleById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/users/roles/${id}`)
    .then((response) => response.data);

export const fetchPermissions = async (): Promise<Permission[]> =>
  axiosInstance.get(`/users/permissions`).then((response) => response.data);

export interface RolePreset {
  id: string;
  name: string;
  permissions: string[];
}

export const fetchRolePresets = async (): Promise<RolePreset[]> =>
  axiosInstance
    .get(`/admin/users/role-presets`)
    .then((response) => response.data);
